import React from "react";

const SvgEmail = props => <svg viewBox="0 0 20 20" {...props}><path fill="currentColor" fillRule="evenodd" d="M17 4a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14zm-.998 3.713l-.033-1.977L10 10 4.024 5.73l-.018 1.99L10 12l6.002-4.287z" /></svg>;

export default SvgEmail;